const DEV_FRONTEND_PORTS = new Set(['3000', '3001', '3100']);

const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '');

const ensureApiSuffix = (value = '') => {
  const trimmed = trimTrailingSlash(value.trim());
  if (!trimmed) return '';
  return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`;
};

const resolveDefaultApiBaseUrl = () => {
  if (typeof window === 'undefined') return 'http://localhost:8000/api';

  const { hostname, port } = window.location;
  if (DEV_FRONTEND_PORTS.has(port)) {
    return `http://${hostname}:8000/api`;
  }

  return '/api';
};

export const API_BASE_URL = ensureApiSuffix(process.env.REACT_APP_API_URL || '') || resolveDefaultApiBaseUrl();

export const API_ROOT_URL = API_BASE_URL.endsWith('/api')
  ? API_BASE_URL.slice(0, -4)
  : trimTrailingSlash(API_BASE_URL);

export const BROWSER_API_BASE_URL = typeof window === 'undefined'
  ? API_BASE_URL
  : trimTrailingSlash(new URL(API_BASE_URL, window.location.origin).toString());

export const resolveApiUrl = (path = '') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
};

export const resolveBackendUrl = (path = '') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_ROOT_URL}${normalizedPath}`;
};
